import { EventTrackingFn } from '../../declarations';
import * as actionTypes from './actionTypes';

export function maybeFetchProfileData(
  homeProfileSlug: string,
  leadToken?: string,
  forceFetch?: boolean,
) {
  return {
    payload: { homeProfileSlug, leadToken, forceFetch },
    type: actionTypes.MAYBE_FETCH_PROFILE_DATA,
  };
}

export function beginLoadingProfileData() {
  return {
    type: actionTypes.BEGIN_LOADING_PROFILE_DATA,
  };
}

export function receiveData(profileData, marketIdentifier, brokerageInfo) {
  return {
    payload: { profileData, marketIdentifier, brokerageInfo },
    type: actionTypes.RECEIVE_DATA,
  };
}

export function errorProfileData(error) {
  return {
    error: true,
    payload: { error },
    type: actionTypes.ERROR_PROFILE_DATA,
  };
}

export function clearProfileData() {
  return {
    type: actionTypes.CLEAR_PROFILE_DATA,
  };
}

export function maybeFetchMarketTrends(market, zipCode) {
  return {
    payload: { market, zipCode },
    type: actionTypes.MAYBE_FETCH_MARKET_TRENDS,
  };
}

export function receiveMarketTrends(marketTrends) {
  return {
    payload: { marketTrends },
    type: actionTypes.RECEIVE_MARKET_TRENDS,
  };
}

export function toInputFlow(addressToken) {
  return {
    payload: { addressToken },
    type: actionTypes.TO_INPUT_FLOW,
  };
}

export const trackEvent: EventTrackingFn = (category, action, label, extra) => {
  return {
    payload: { category, action, label, extra },
    type: actionTypes.TRACK_EVENT,
  };
};

export function trackLead(keywords) {
  return {
    payload: { keywords },
    type: actionTypes.TRACK_LEAD,
  };
}
